import { ReactComponent as BikeIcon } from "../../assets/products/shared/icons/bike.svg";
import { ReactComponent as AirplaneIcon } from "../../assets/products/shared/icons/airplane.svg";
import { ReactComponent as HeartIcon } from "../../assets/products/shared/icons/heart.svg";
import { ReactComponent as HospitalIcon } from "../../assets/products/shared/icons/hospital.svg";
import { ReactComponent as EmergencyIcon } from "../../assets/products/shared/icons/emergency.svg";
import { ReactComponent as BruisedIcon } from "../../assets/products/shared/icons/Bruised.svg";
import { ReactComponent as FallIcon } from "../../assets/products/shared/icons/Fall.svg";

type IconMap = Record<string, React.ComponentType<React.SVGProps<SVGSVGElement>>>;

const iconMap: IconMap = {
    Bike: BikeIcon,
    Airplane: AirplaneIcon,
    Heart: HeartIcon,
    Hospital: HospitalIcon,
    Emergency: EmergencyIcon,
    Bruised: BruisedIcon,
    Fall: FallIcon,
};

interface PlanIconProps {
    iconName: string;
    className?: string;
}

export const PlanIcon = ({ iconName, className = "w-3 h-3" }: PlanIconProps) => {
    const IconComponent = iconMap[iconName];

    if (!IconComponent) {
        console.warn(`Icon "${iconName}" not found in iconMap`);
        return null;
    }

    return <IconComponent className={className} />;
};
